
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot-password/[id]",
      function () {
        return require("private-next-pages/forgot-password/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forgot-password/[id]"])
      });
    }
  